import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import { injectIntl } from "react-intl";
import "./PageContent.scss";
class PageContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    const { intl } = this.props;
    console.log("Intl:", intl);

    // Nếu intl không có, render fallback
    if (!intl) return <p>Không có intl</p>;

    const message = intl.formatMessage({ id: "product.a5.page-content.a31" });
    console.log(message);
    return (
      <>
        <>
          <section className="page-content page-content-a5">
            <div className="title-box">
              <p className="title-box-one">
                <FormattedMessage id="product.a5.page-content.a1" />
              </p>
              <p className="title-box-two">
                <FormattedMessage id="product.a5.page-content.a2" />
              </p>
              {/* <div className="order-now-btn-a5">
                <Link to="/order/a5" className="btn-order">
                  <FormattedMessage
                    id="home.slider.a4"
                    defaultMessage="Order Now"
                  />
                </Link>
              </div> */}
            </div>

            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                className="feature-img"
                src="/static/images/product/a5-main.png"
                data-src="/static/images/product/a5-main.png"
                alt="none"
              />
            </div>
            <div className="scroll-mouse" style={{ bottom: "0%" }}>
              <img
                style={{ width: 30, height: 30 }}
                src="/static/images/mouse-w.png"
                alt="none"
              />
              <p style={{ color: "#FFFFFF", fontSize: 12, marginTop: 10 }}></p>
            </div>
          </section>
          <section className="page-content page-content-2">
            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                className="feature-img"
                src="/static/images/product/a5-module1-2x.png"
                data-src="/static/images/product/a5-module1-2x.png"
                alt="none"
              />
            </div>
            <div className="title-box">
              <p className="text_10 bold-text text-ai">
                <FormattedMessage id="product.a5.page-content.a4" />
              </p>
              <p className="title-box-page-content-2">
                <FormattedMessage id="product.a5.page-content.a5" />
                <br /> <FormattedMessage id="product.a5.page-content.a6" />
              </p>
            </div>
            <div className="function-box">
              <div>
                <FormattedMessage id="product.a5.page-content.a7" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a8" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a9" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a10" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a11" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a12" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a13" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a14" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a15" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a16" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a17" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a18" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a18_1" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a18_2" />
              </div>
              <div>
                <FormattedMessage id="product.a5.page-content.a18_3" />
              </div>
            </div>
          </section>
          <section className="page-content page-content-a5-1">
            <div className="left-title-box">
              <span className="text_24">32</span>
              <span className="text_25">&nbsp; INCH</span>
              <br />
              <img
                className="image_2"
                referrerPolicy="no-referrer"
                src="https://lanhu-oss.lanhuapp.com/SketchPng51d007c2031a5b218f2a554568583021a00cfc62230930af9154ab1e3b0ceb80"
                alt="none"
              />
              <br />
              <p className="text_10 bold-text" style={{ textAlign: "left" }}>
                HD SCREEN
              </p>
              <p>
                <FormattedMessage id="product.a5.page-content.a19" /> <br />
                <FormattedMessage id="product.a5.page-content.a20" />
              </p>
              {/* <div className="order-now-btn-a5-1">
                <Link to="/order/a5" className="btn-order">
                  <FormattedMessage
                    id="home.slider.a4"
                    defaultMessage="Order Now"
                  />
                </Link>
              </div> */}
            </div>
            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                className="feature-img mobile-adjust"
                src="/static/images/product/a5-jishen.png"
                data-src="/static/images/product/a5-jishen.png"
                alt="none"
              />
            </div>
          </section>
          <section
            className="page-content page-content-a5-2"
            style={{ marginTop: 10 }}
          >
            <div className="rightB-title-box">
              <p className="text_10 bold-text">
                <FormattedMessage id="product.a5.page-content.a21" /> <br />
                <FormattedMessage id="product.a5.page-content.a22" />
              </p>
              <p className="text_center">
                <FormattedMessage id="product.a5.page-content.a24" />
              </p>
              {/* <div className="order-now-btn-a5-2">
                <Link to="/order/a5" className="btn-order">
                  <FormattedMessage
                    id="home.slider.a4"
                    defaultMessage="Order Now"
                  />
                </Link>
              </div> */}
            </div>
            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                className="feature-img mobile-adjust"
                src="/static/images/product/a5-dizuo.png"
                data-src="/static/images/product/a5-dizuo.png"
                alt="none"
              />
            </div>
          </section>
          <section
            className="page-content page-content-a5-4"
            style={{ marginTop: 10 }}
          >
            <div className="left-title-box">
              <span className="text_24">AI</span>
              <br />
              <p className="text_10 bold-text" style={{ textAlign: "left" }}>
                <FormattedMessage id="product.a5.page-content.a25" />
                <br /> CAMERA <br />
                1080P
              </p>
              {/* <div className="order-now-btn-a5-4">
                <Link to="/order/a5" className="btn-order">
                  <FormattedMessage
                    id="home.slider.a4"
                    defaultMessage="Order Now"
                  />
                </Link>
              </div> */}
            </div>
            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                className="feature-img mobile-adjust"
                src="/static/images/product/a5-camera.png"
                data-src="/static/images/product/a5-camera.png"
                alt="none"
              />
            </div>
          </section>
          <section
            className="page-content page-content-a5-6"
            style={{ marginTop: 10 }}
          >
            <div className="rightB-title-box">
              <p
                className="text_10 bold-text"
                style={{ textAlign: "left", paddingLeft: 20 }}
              >
                <FormattedMessage id="product.a5.page-content.a26" /> <br />
                <FormattedMessage id="product.a5.page-content.a27" />
              </p>
              <table className="param-box">
                <tbody>
                  <tr>
                    <td>50K Hz</td>
                    <td>5mm</td>
                  </tr>
                  <tr>
                    <td>
                      <FormattedMessage id="product.a5.page-content.a28" />
                    </td>
                    <td>
                      <FormattedMessage id="product.a5.page-content.a29" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {/* <div className="order-now-btn-a5-6">
                        <Link to="/order/a5" className="btn-order">
                          <FormattedMessage
                            id="home.slider.a4"
                            defaultMessage="Order Now"
                          />
                        </Link>
                      </div> */}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                className="feature-img mobile-adjust"
                src="/static/images/product/a5-dingpeng.png"
                data-src="/static/images/product/a5-dingpeng.png"
                alt="none"
              />
            </div>
          </section>
          <section className="page-content" style={{ marginTop: 10 }}>
            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                className="feature-img"
                src="/static/images/product/a5-spbdcgq.png"
                data-src="/static/images/product/a5-spbdcgq.png"
                alt="none"
              />
            </div>
            <div className="overlap-box">
              <img
                className="overlap-img"
                src="/static/images/product/curve.png"
                data-src="/static/images/product/curve.png"
                alt="none"
              />
            </div>
            <div className="title-box">
              <p className="text_10 bold-text text-sensor">
                <FormattedMessage id="product.a5.page-content.a30" />
              </p>
            </div>
          </section>
          <section
            className="page-content page-content-a5-3"
            style={{ marginTop: 10 }}
          >
            <div className="right-title-box txt-adjust">
              <span className="text_24 bold-text">
                <FormattedMessage id="product.a5.page-content.a31" />
                <br />
                <FormattedMessage id="product.a5.page-content.a32" />
              </span>
              <p className="balance-desc" style={{ marginTop: 20 }}>
                <FormattedMessage id="product.a5.page-content.a33" /> <br />
                <FormattedMessage id="product.a5.page-content.a34" /> <br />
                <FormattedMessage id="product.a5.page-content.a35" /> <br />
                <FormattedMessage id="product.a5.page-content.a37" />
              </p>
              {/* <div className="order-now-btn-a5-3">
                <Link to="/order/a5" className="btn-order">
                  <FormattedMessage
                    id="home.slider.a4"
                    defaultMessage="Order Now"
                  />
                </Link>
              </div> */}
            </div>
            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                style={{ width: "80vw", margin: "0 auto" }}
                className="feature-img mobile-adjust txt-adjust balance-img"
                src="/static/images/product/a5-sgcs.png"
                data-src="/static/images/product/a5-sgcs.png"
                alt="none"
              />
            </div>
          </section>
          <section
            className="page-content page-content-a5-5"
            style={{ marginTop: 10 }}
          >
            <div
              className="left-title-box"
              style={{ bottom: "35%", marginTop: 50 }}
            >
              <span className="text_10 bold-text">
                <FormattedMessage id="product.a5.page-content.a38" /> <br />
                <FormattedMessage id="product.a5.page-content.a39" />
              </span>
              <br />

              <div className="tzt-item">
                <FormattedMessage id="product.a5.page-content.a40" />
              </div>
              <br />
              <div className="tzt-item">
                <FormattedMessage id="product.a5.page-content.a41" />
              </div>
              <br />
              <div className="tzt-item">
                <FormattedMessage id="product.a5.page-content.a42" />
              </div>
              <br />
              <div className="tzt-item">
                <FormattedMessage id="product.a5.page-content.a43" />
              </div>
              {/* <div className="order-now-btn-a5-5">
                <Link to="/order/a5" className="btn-order">
                  <FormattedMessage
                    id="home.slider.a4"
                    defaultMessage="Order Now"
                  />
                </Link>
              </div> */}
            </div>
            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                className="feature-img tzt-img"
                src="/static/images/product/a5-tzt.png"
                data-src="/static/images/product/a5-tzt.png"
                alt="none"
              />
            </div>
          </section>
          <section className="page-content">
            <div className="title-box txt-will">
              <span className="bold-text">
                <FormattedMessage id="product.a5.page-content.a44" /> <br />
                <FormattedMessage id="product.a5.page-content.a45" />
              </span>
            </div>
            <div
              className="features-box"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <img
                className="feature-img mobile-adjust"
                src="/static/images/product/a5-will.png"
                data-src="/static/images/product/a5-will.png"
                alt="none"
              />
            </div>
          </section>
        </>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(PageContent))
);
